
import caseAPI from '@/api/cases';
import tasksApi from '@/api/tasks';

export default {
  name: 'CaseTaskSelect',

  props: {
    value: {
      type: String | null,
      required: true,
    },
    case_uuid: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: false,
    },
    isRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      loading: true,
      case: {},
      tasks: [],
    };
  },

  computed: {
    selectedList: {
      get: function () {
        if (this.value) {
          return this.tasks.filter((item) => this.value.includes(item.uuid));
        }
      },
      set: function (newVal) {
        if (newVal) {
          this.$emit('input', newVal.uuid);
        } else {
          this.$emit('input', null);
        }
      },
    },
  },

  mounted() {
    this.getCase(this.case_uuid);
  },

  methods: {
    getCase(case_uuid) {
      caseAPI.getCase(case_uuid).then((rsp) => {
        this.case = rsp.data.data;
        this.getTasks(this.case.uuid);
      });
    },

    getTasks(case_uuid) {
      this.loading = true;
      tasksApi
        .getAllTasks({
          params: {
            'filter[taskable_uuid]': case_uuid,
            'filter[taskable_type]': 'case',
            'filter[show_child_tasks]': true,
            per_page: 250,
          },
        })
        .then((rsp) => {
          this.tasks = rsp.data.data;
          this.loading = false;
        })
        .catch((err) => {
          this.loading = false;
          this.$nuxt.$emit('notification', err.response.data.message, 'warning', true);
        });
    },
  },

  watch: {
    case_uuid(new_val) {
      if (new_val !== null && new_val !== undefined) {
        this.getTasks(new_val);
      }
    },
  },
};
